// src/components/intake/IntakeAccounts.js
//
// Ticket 066 (Advisor Intake I6), screen 4.1. Net worth (euros) and the highest
// combined balance outside Spain (US dollars) on ONE screen, two required single
// choices. Small copy of the Snapshot's AssetsAndNetWorthStep (053 D9; the Snapshot
// page is not imported). Band lists come from sharedOptions; "none" is a real value
// of the accounts list. There is no Skip and no "Not sure".

import React from 'react'
import IntakeFollowUp from './IntakeFollowUp'
import {
  NET_WORTH_QUESTION, FOREIGN_ACCOUNTS_QUESTION, NET_WORTH_BAND_OPTIONS, FOREIGN_ACCOUNT_BAND_OPTIONS,
} from '../../lib/intake/intakeConfig'
import { known } from '../../lib/intake/section1Facts'

const asFact = (value) => (value === null || value === undefined ? undefined : known(value))

export default function IntakeAccounts({ assets, onChange }) {
  return (
    <div className="u-stack-xl">
      <IntakeFollowUp
        question={NET_WORTH_QUESTION}
        options={NET_WORTH_BAND_OPTIONS}
        fact={asFact(assets.netWorth)}
        onPick={(fact) => onChange('netWorth', fact.value)}
      />
      <IntakeFollowUp
        question={FOREIGN_ACCOUNTS_QUESTION}
        options={FOREIGN_ACCOUNT_BAND_OPTIONS}
        fact={asFact(assets.foreignAccounts)}
        onPick={(fact) => onChange('foreignAccounts', fact.value)}
      />
    </div>
  )
}
